<template>
  <div class="home section contrast-section">
    <div class="container">
      <div class="section-content">
        <div class="has-text-centered">
          <div class="logo-wrapper">
            <img src="@/assets/logo.svg" alt="">
          </div>
        </div>
        <br>
        <div class="box inner-section">

          <div class="has-text-centered">
            <div
              v-if="event"
            >
              <div>
                <h1 class="is-size-6 has-text-weight-semibold">{{ event.name }}</h1>
              </div>

              <div v-if="event.registrationPeriod">
                <div
                  v-if="registrationStarted && !registrationEnded"
                >
                  <br>
                  <router-link
                    :to="{ name:'register-profile' }"
                    class="button main-cta is-warning is-medium has-text-weight-semibold"
                  >Register</router-link>
                </div>
                <div
                  v-else-if="!registrationStarted && !registrationEnded"
                >
                  <span class="is-size-3"><AlertCircleOutline /></span>
                  <p class="is-size-5">Registrations open on<br><b>{{ formatDate(event.registrationStartDate, 'MMM Do YYYY') }}</b></p>
                  <br>
                </div>
                <div
                  v-else-if="registrationEnded"
                >
                  <span class="is-size-3"><AlertCircleOutline /></span>
                  <p class="is-size-5">Registrations for this event<br>have closed</p>
                  <br>
                </div>

              </div>

              <div v-else>
                <router-link
                  :to="{ name:'register-profile' }"
                  class="button main-cta is-primary is-medium has-text-weight-semibold mt-15"
                >Register</router-link>
              </div>
            </div>
            <div v-else>
              <h1 class="is-size-4">The GMA World Championships website is not currently active.<br><br>Please follow the <a href="https://globalmartialarts.university/">Global Martial Arts University</a> to stay up to date on future online competitions.</h1>
              <!-- <p class="is-size-5 has-text-grey">There are currently no active events to participate in.</p> -->
            </div>
            <!-- <p class="has-text-grey-light">Have an account?</p>
            <router-link
              :to="{ name:'login' }"
              class="button is-dark"
            >Login</router-link> -->
          </div>
        </div>
        <div class="has-text-centered disclaimer">
          <p class="is-size-7">© {{ currentYear }} Global Martial Arts University and Hodgy LLC. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '@/helpers/auth'
import redirectMixin from '@/mixins/redirects'
import datesMixin from '@/mixins/dates'
import AlertCircleOutline from 'vue-material-design-icons/AlertCircleOutline.vue'
import moment from 'moment'

export default {
  name: 'Home',
  mixins: [redirectMixin, datesMixin],
  components: {
    AlertCircleOutline
  },
  data () {
    return {
      event: false
    }
  },
  mounted () {
    const user = Auth.getUser()
    if (user !== null) {
      this.redirectUser(user)
    } else {
      this.$store
        .dispatch('admin/GET_ACTIVE_EVENT')
        .then(res => {
          if (res.data.events.length > 0) {
            this.event = res.data.events[0]
          }
        })
    }
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    },
    registrationStarted () {
      return moment(this.event.registrationStartDate).isSameOrBefore(moment())
    },
    registrationEnded () {
      return moment(this.event.registrationEndDate).isSameOrBefore(moment())
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 100%;
}
</style>
